
<template>
  <div>
    <!-- <mheader></mheader> -->
    <div v-show="tableData.length > 0" style="width: 1300px; margin: 0 auto">
      <!-- 表单内容 -->
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2 font">
          <img
            src="../../static/images/kucun.png"
            style="width: 1.5rem; height: 1.5rem"
            class="mb-lg-1"
            alt=""
          />
          <span
            class="p-1"
            style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            "
          >
            移库管理
          </span>
          <span class="ml-5">
            <span class="mt-2">
              总共有
              <span style="color: green; font-size: 20px">{{ Record }}</span>
              条数据
            </span>
          </span>
          <span
            class="float-right span_close"
            style="
              display: block;
              width: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 25px;
            "
            @click="$router.go(-1)"
          >
            &times;
          </span>
        </p>

        <p class="query mb-2 mt-2">
          <span style="font-weight: 600"
            >移库详细(凡是没有上传图片的药品，均不显示！双击药品名称或者生产厂家可以快速检索！)</span
          >
        </p>
        <div class="row ml-2 mb-2">
          <div class="col-lg-9">
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">药品名称:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font heit"
                          v-model="searchForm.ypmc"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">批号:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.ph"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">生产厂家:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.cdmc"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">规格:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.gg"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="row ml-lg-3">
              <button class="bg-primary button_zi heit" @click="Search()">
                查询
              </button>

              <button
                class="bg-primary button_zi heit ml-5"
                @click="changePage()"
              >
                移库记录
              </button>
            </div>
          </div>
        </div>

        <table
          v-if="searchData.length > 0"
          class="table table-striped table-hover"
          ref="print"
        >
          <thead>
            <tr style="white-space: nowrap" class="text-center">
              <th>药品名称</th>
              <th>产地名称</th>
              <th>库区</th>
              <th>规格</th>
              <th>批号</th>
              <th>单位</th>
              <th>单价</th>
              <th>零/整</th>
              <th>包装</th>
              <th style="color: green">数量</th>
              <th>有效期至</th>
              <th>入账日期</th>
              <th>可销售数量</th>
              <!-- <th>打折情况</th> -->
              <!-- <th>返利情况</th> -->
              <th>移库数量</th>
              <th>移库管理</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in searchData"
              :key="index"
              class="text-center"
            >
              <td class="jz_middle" @dblclick="onInputdrugName(index)">
                {{ item.drugName }}
              </td>
              <td class="jz_middle" @dblclick="onInputcustomerName(index)">
                {{ item.productFactory }}
              </td>
              <td class="jz_middle">{{ item.storeNo }}</td>
              <td class="jz_middle">{{ item.spec }}</td>
              <td class="jz_middle">{{ item.batchNum }}</td>
              <td class="jz_middle">{{ item.unit }}</td>
              <td class="jz_middle">{{ item.price }}</td>
              <td class="jz_middle">{{ item.isRetail | lin }}</td>
              <td class="jz_middle">{{ item.pack }}</td>
              <td class="jz_middle" style="color: green">
                {{ item.storeNum }}
              </td>
              <td class="jz_middle">{{ item.dueDate }}</td>
              <td class="jz_middle">{{ item.inAccountDate | formatUTC }}</td>
              <td class="jz_middle">{{ item.canSaleNum }}</td>
              <!-- <td class="jz_middle">{{item.disCountRate | rate}}</td> -->
              <!-- <td class="jz_middle">{{item.isPromotion}}</td> -->
              <td class="jz_middle">
                <input
                  type="text"
                  class="text-center"
                  style="width: 60px"
                  v-model="item.value"
                />
              </td>
              <td class="jz_middle">
                <button
                  class="bg-primary button_zi heit"
                  @click="Createretailmove(index)"
                >
                  确定
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="table table-striped table-hover" ref="print" v-else>
          <thead>
            <tr style="white-space: nowrap" class="text-center">
              <th>药品名称</th>
              <th>产地名称</th>
              <th>库区</th>
              <th>规格</th>
              <th>批号</th>
              <th>单位</th>
              <th>单价</th>
              <th>零/整</th>
              <th>包装</th>
              <th style="color: green">数量</th>
              <th>有效期至</th>
              <th>入账日期</th>
              <th>可销售数量</th>
              <!-- <th>打折情况</th> -->
              <!-- <th>返利情况</th> -->
              <th>移库数量</th>
              <th>移库管理</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in tableData"
              :key="index"
              class="text-center"
            >
              <td class="jz_middle" @dblclick="onInputdrugName(index)">
                {{ item.drugName }}
              </td>
              <td class="jz_middle" @dblclick="onInputcustomerName(index)">
                {{ item.productFactory }}
              </td>
              <td class="jz_middle">{{ item.storeNo }}</td>
              <td class="jz_middle">{{ item.spec }}</td>
              <td class="jz_middle">{{ item.batchNum }}</td>
              <td class="jz_middle">{{ item.unit }}</td>
              <td class="jz_middle">{{ item.price }}</td>
              <td class="jz_middle">{{ item.isRetail | lin }}</td>
              <td class="jz_middle">{{ item.pack }}</td>
              <td class="jz_middle" style="color: green">
                {{ item.storeNum }}
              </td>
              <td class="jz_middle">{{ item.dueDate }}</td>
              <td class="jz_middle">{{ item.inAccountDate | formatUTC }}</td>
              <td class="jz_middle">{{ item.canSaleNum }}</td>
              <!-- <td class="jz_middle">{{item.disCountRate | rate}}</td> -->
              <!-- <td class="jz_middle">{{item.isPromotion}}</td> -->
              <td class="jz_middle">
                <input
                  type="text"
                  class="text-center"
                  style="width: 60px"
                  v-model="item.value"
                />
              </td>
              <td class="jz_middle">
                <button
                  class="bg-primary button_zi heit"
                  @click="Createretailmove(index)"
                >
                  确定
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- 分页 -->
        <nav
          aria-label="Page navigation"
          style="text-align: center"
          class="mb-1"
        >
          <ul class="pagination">
            <li
              class="page-item ml-5"
              :class="PageNo <= 1 ? 'disabled' : ''"
              @click="prePage()"
            >
              <a aria-label="Previous" class="page-link">
                <span aria-hidden="true">&laquo;</span>
              </a>
            </li>
            <li
              :class="index == PageNo ? 'active' : ''"
              class="page-item"
              v-for="index of Pcount"
              :key="index"
              @click="curPage(index)"
            >
              <a class="page-link" v-if="index <= 20">{{ index }}</a>
              <a class="page-link" v-if="index > 20 && index == Pcount - 1"
                >...</a
              >
              <a class="page-link" v-if="index > 20 && index == Pcount">{{
                Pcount
              }}</a>
            </li>

            <li
              class="page-item"
              :class="PageNo >= Pcount ? 'disabled' : ''"
              @click="nextPage()"
            >
              <a aria-label="Next" class="page-link">
                <span aria-hidden="true">&raquo;</span>
              </a>
            </li>
            <li class="ml-5"></li>
          </ul>
        </nav>
        <p class="text-center">
          <img
            src="../../static/images/tuding.png"
            style="width: 1.5rem; height: 1.5rem"
            alt=""
          />
        </p>
      </div>
      <!-- container -->
    </div>

    <div
      v-show="Pcount === 0"
      style="width: 1300px; margin: 0 auto"
      id="v-content"
      :style="{ minHeight: Height + 'px' }"
    >
      <!-- 表单内容 -->
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2 font">
          <img
            src="../../static/images/kucun.png"
            style="width: 1.5rem; height: 1.5rem"
            class="mb-lg-1"
            alt=""
          />
          <span
            class="p-1"
            style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            "
          >
            库存查询
          </span>
          <span class="ml-5">
            <span class="mt-2">
              总共有
              <span style="color: green; font-size: 20px">{{ Record }}</span>
              条数据
            </span>
            <span>
              <span class="ml-3"> 总金额: </span>
              <span style="color: red; font-size: 15px">
                ¥{{ totalPurchMoney }}
              </span>
            </span>
          </span>
          <span
            class="float-right span_close"
            style="
              display: block;
              width: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 25px;
            "
            @click="$router.go(-1)"
          >
            &times;
          </span>
        </p>

        <p class="query mb-2 mt-2">
          <span style="font-weight: 600"
            >移库详细(凡是没有上传图片的药品，均不显示！双击药品名称或者生产厂家可以快速检索！)</span
          >
        </p>
        <div class="row ml-2 mb-2">
          <div class="col-lg-9">
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">药品名称:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font heit"
                          v-model="searchForm.ypmc"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">批号:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.ph"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">生产厂家:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.cdmc"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">规格:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.gg"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="row ml-lg-3">
              <button class="bg-primary button_zi heit" @click="Search()">
                查询
              </button>
              <button
                class="bg-primary button_zi heit ml-5"
                @click="changePage()"
              >
                移库记录
              </button>
            </div>
          </div>
        </div>
        <img
          src="../../static/images/wushuju.jpg"
          style="width: 300px; height: 300px; display: block; margin: 0 auto"
          alt=""
        />
        <p class="text-center">
          <img
            src="../../static/images/tuding.png"
            style="width: 1.5rem; height: 1.5rem"
            alt=""
          />
        </p>
      </div>
      <!-- container -->
    </div>

    <div>
      <transition name="fade">
        <loading v-show="isLoading"> </loading>
      </transition>
    </div>

    <!-- 弹出提示框 -->

    <div
      class="modal fade"
      id="myModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div
          class="modal-content"
          style="
            width: 500px;
            height: 200px;
            position: relative;
            top: 300px;
            left: 200px;
            margin-bottom: 50px;
          "
        >
          <!-- <div>
                                    <button type="button" class="close m-0 p-1" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div> -->
          <div class="modal-body" style="font-size: 20px">
            <div
              style="
                width: 300px;
                height: 125px;
                margin: 0 auto;
                text-align: center;
              "
            >
              <p style="line-height: 125px; color: green">是否执行移库操作?</p>
            </div>

            <div style="text-align: right">
              <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
                @click="moveQuren()"
                :disabled="isDisable"
              >
                <span aria-hidden="true"></span>是
              </button>
              <button
                type="button"
                class="btn btn-info ml-3"
                data-dismiss="modal"
              >
                <span aria-hidden="true"></span>否
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 提示是否是整数提示框 -->

    <div
      class="modal fade"
      id="myModal1"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div
          class="modal-content"
          style="
            width: 500px;
            height: 200px;
            position: relative;
            top: 300px;
            left: 200px;
            margin-bottom: 50px;
          "
        >
          <!-- <div>
                                    <button type="button" class="close m-0 p-1" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div> -->
          <div class="modal-body" style="font-size: 20px">
            <div
              style="
                width: 300px;
                margin: 0 auto;
                text-align: center;
                margin-bottom: 30px;
                margin-top: 30px;
                color: green;
              "
            >
              你的移库数量非整件倍数，确定继续移库么？
            </div>

            <div style="text-align: right">
              <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
                @click="moveQuren()"
                :disabled="isDisable"
              >
                <span aria-hidden="true"></span>是
              </button>
              <button
                type="button"
                class="btn btn-info ml-3"
                data-dismiss="modal"
              >
                <span aria-hidden="true"></span>否
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from "../components/Loading.vue";
import { async } from "q";
export default {
  name: "SaleQuery",
  data() {
    return {
      Height: 0,
      searchForm: {
        ypmc: "",
        cdmc: "",
        ph: "",
        gg: "",
      }, //搜索内容
      searchData: [], //搜索返回的清单
      isLoading: false,
      tableData: [],
      Record: "", //总记录数
      Pcount: "", //总页数
      PageNo: 1, //当前页码
      excelData: [],
      totalPurchMoney: "",
      id: "",
      GoodsNum: "",
      bz: "",

      isDisable: false,
    };
  },
  components: {
    // mheader,
    // mfooter,
    Loading,
  },
  computed: {},
  filters: {
    //过滤器时间转换
    //时间转换
    formatUTC: function (utc_datetime) {
      return utc_datetime.replace(/T/gi, "  ").substring(0, 20);
    },
    lin: function (data) {
      if (data == 1) {
        return "零";
      } else {
        return "整";
      }
    },
    rate: function (rate) {
      if (rate == 1) {
        return "不打折";
      } else {
        return "打" + rate * 10 + "折";
      }
    },
  },

  methods: {
    changePage() {
      this.$router.push({ path: "/moveRecord" });
    },
    //确认移库

    moveQuren: async function () {
      this.isDisable = true;
      const that = this;
      const { data: res } = await that.$http.post("Dls/getFun", {
        action: "createretailmove",
        obj: JSON.stringify({
          StoreId: that.id,
          GoodsNum: that.GoodsNum,
          ClerkNums: "",
        }),
      });
      // console.log(res)
      if (res.isok) {
        alert("移库成功");
        this.isDisable = false;
        if (!res.data.result.isSucceed) {
          alert(res.data.result.msg);
        }
      } else {
        alert(res.message);
        this.isDisable = false;
      }
    },

    Createretailmove: async function (index) {
      const that = this;
      if (that.searchData.length > 0) {
        that.GoodsNum = that.searchData[index].value;
        that.id = that.searchData[index].storeID;
        that.bz = that.searchData[index].pack;
      } else {
        that.GoodsNum = that.tableData[index].value;
        // console.log(that.GoodsNum)
        that.id = that.tableData[index].storeID;
        that.bz = that.tableData[index].pack;
      }
      //  console.log(that.bz)
      let reg = /^[+]{0,1}(\d+)$/;
      if (!that.GoodsNum) {
        alert("您输入的数量不能为空！");
      } else if (!reg.test(that.GoodsNum)) {
        alert("您输入的数量必须为正整数！");
      } else if (that.GoodsNum % that.bz !== 0) {
        $("#myModal1").modal();
      } else {
        $("#myModal").modal();
        //      const { data: res } = await that.$http.post('Dls/getFun', {
        //        action: 'createretailmove',
        //        obj: JSON.stringify({
        //             StoreId:that.id,
        //             GoodsNum:that.GoodsNum,
        //             ClerkNums:'',
        //        })
        //      })
        // // console.log(res)
        //    if(res.isok){
        //            that.$message.success("移库成功")
        //            if(!res.data.result.isSucceed)
        //            {
        //               that.$message.success(res.data.result.msg)
        //            }
        //    }
      }
    },

    searchEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.Search();
      }
    },
    //导出方法
    //导出查询页 默认全部查询
    exportExcel() {
      const that = this;
      require.ensure([], async () => {
        const { export_json_to_excel } = require("../Excel/Export2Excel"); //注意这个Export2Excel路径
        const tHeader = [
          "药品名称",
          "产地名称",
          "库区",
          "规格",
          "批号",
          "单位",
          "单价",
          "零/整",
          "包装",
          "数量",
          "有效期",
          "入账日期",
          "打折情况",
          "返利情况",
        ]; // 上面设置Excel的表格第一行的标题
        const filterVal = [
          "drugName",
          "productFactory",
          "storeNo",
          "spec",
          "batchNum",
          "unit",
          "price",
          "isRetail",
          "pack",
          "storeNum",
          "dueDate",
          "inAccountDate",
          "disCountRate",
          "isPromotion",
        ]; // 上面的index、nickName、name是tableData里对象的属性key值
        await that.getExcelData();
        const list = that.excelData;
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "库存查询"); //最后一个是表名字
      });
    },
    //导出当前页
    exportExcel1() {
      require.ensure([], () => {
        const { export_json_to_excel } = require("../Excel/Export2Excel"); //注意这个Export2Excel路径
        const tHeader = [
          "药品名称",
          "产地名称",
          "库区",
          "规格",
          "批号",
          "单位",
          "单价",
          "零/整",
          "包装",
          "数量",
          "有效期",
          "入账日期",
          "打折情况",
          "返利情况",
        ]; // 上面设置Excel的表格第一行的标题
        const filterVal = [
          "drugName",
          "productFactory",
          "storeNo",
          "spec",
          "batchNum",
          "unit",
          "price",
          "isRetail",
          "pack",
          "storeNum",
          "dueDate",
          "inAccountDate",
          "disCountRate",
          "isPromotion",
        ]; // 上面的index、nickName、name是tableData里对象的属性key值
        if (this.searchData.length > 0) {
          const list = this.searchData; //把要导出的数据tableData存到list
          const data = this.formatJson(filterVal, list);
          export_json_to_excel(tHeader, data, "库存查询"); //最后一个是表名字
        } else {
          const list = this.tableData; //把要导出的数据tableData存到list
          const data = this.formatJson(filterVal, list);
          export_json_to_excel(tHeader, data, "库存查询"); //最后一个是表名字
        }
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    onInputdrugName: function (index) {
      if (this.searchData.length > 0) {
        this.searchForm.ypmc = this.searchData[index].drugName;
      } else {
        this.searchForm.ypmc = this.tableData[index].drugName;
      }
    },
    onInputcustomerName: function (index) {
      if (this.searchData.length > 0) {
        this.searchForm.cdmc = this.searchData[index].productFactory;
      } else {
        this.searchForm.cdmc = this.tableData[index].productFactory;
      }
    },
    getCanmoveretailQuery: async function (PageIndex) {
      // this.isLoading=true;
      this.PageNo = PageIndex || this.PageNo;
      const { data: res } = await this.$http.post("Dls/getFun", {
        action: "CanmoveretailQuery",
        obj: JSON.stringify({
          PageIndex,
          PageSize: 20,
        }),
      });
      // console.log(res)
      if (res.isok) {
        const obj = res.data;
        this.tableData = obj.rows;
        this.Pcount = obj.pcount;
        this.Record = obj.record;
        this.totalPurchMoney = obj.totalPurchMoney;
        // this.isLoading=false
      }
    },
    getExcelData: async function () {
      const { data: res } = await this.$http.post("Dls/getFun", {
        action: "CanmoveretailQuery",
        obj: JSON.stringify({
          PageIndex: 1,
          PageSize: 50000,
          DrugName: this.searchForm.ypmc.trim(),
          BatchNum: this.searchForm.ph.trim(),
          ProductFactory: this.searchForm.cdmc.trim(),
          Spec: this.searchForm.gg.trim(),
        }),
      });
      // console.log(res)
      if (res.isok) {
        const obj = res.data;
        this.excelData = obj.rows;
      }
    },
    //搜索
    Search: async function (PageIndex) {
      const that = this;
      // search 是 v-model="search" 的 search
      that.isLoading = true;
      //这里加表单验证，这块就不用我说了吧
      //假设表单验证通过，这时候就可以ajax提交表单
      if (!PageIndex) {
        PageIndex = 1;
      }
      that.PageNo = PageIndex || that.PageNo;
      const { data: res } = await this.$http.post("Dls/getFun", {
        action: "CanmoveretailQuery",
        obj: JSON.stringify({
          PageIndex,
          PageSize: 20,
          DrugName: that.searchForm.ypmc.trim(),
          BatchNum: that.searchForm.ph.trim(),
          ProductFactory: that.searchForm.cdmc.trim(),
          Spec: that.searchForm.gg.trim(),
        }),
      });
      // console.log(res)
      if (res.isok) {
        const obj = res.data;
        if (that.Pcount === 0) {
          that.tableData = obj.rows;
        } else {
          that.searchData = obj.rows;
        }
        that.Pcount = obj.pcount;
        that.Record = obj.record;
        that.isLoading = false;
        if (obj.pcount == 0) {
          alert("没有符合条件的信息");
          that.getCanmoveretailQuery();
        }
      }
    },

    curPage: function (index) {
      if (this.searchData.length > 0) {
        this.Search(index);
      } else {
        this.getCanmoveretailQuery(index);
      }
    },
    //上一页
    prePage: function () {
      if (this.PageNo > 1) {
        this.PageNo--;
        if (this.searchData.length > 0) {
          this.Search(this.PageNo);
        } else {
          this.getCanmoveretailQuery(this.PageNo);
        }
      }
    },
    //下一页
    nextPage: function () {
      if (this.PageNo < this.Pcount) {
        this.PageNo++;
        if (this.searchData.length > 0) {
          this.Search(this.PageNo);
        } else {
          this.getCanmoveretailQuery(this.PageNo);
        }
      }
    },
    //搜索功能
    // 打印
    start_print() {
      this.$print(this.$refs.print); //$refs的值要和html里的ref一致
    },
  },
  mounted() {},
  created() {
    this.getCanmoveretailQuery();
  },
};
</script>
<style scoped>
.table-hover > tbody > tr:hover {
  background-color: #dee2e6 !important;
}
.font {
  font-size: 15px;
}
.font_yz {
  font-size: 1px;
  color: red;
}
.button_zi {
  text-shadow: #000 1px 0 0;
  border-radius: 5px;
  border: none;
  color: azure;
}
.heit {
  height: 1.5rem;
}
.span_close:hover {
  color: #3190e8;
}

.autocut {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  -khtml-text-overflow: ellipsis;
  -moz-text-overflow: ellipsis;
  -webkit-text-overflow: ellipsis;
}
.jz_middle {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/pages/PricingManagement.vue